module.exports = __webpack_public_path__ + "img/48exp.fe8f50c6.jpg";